import { Paper, Typography, Box, LinearProgress } from "@mui/material";
import { BudgetType, SubBudgetItem } from "../../types";

const SubBudget = (props: { Item: SubBudgetItem, Type: BudgetType, OnClick?: () => void }) => {
    const item = props.Item;
    const isIncomeBudget = props.Type === BudgetType.Income;
    const isCombinedBudget = props.Type === BudgetType.Combined;
    const incomeTotal = item.variant?.incomeAmount ?? 0;
    const incomeSpent = item.incomeAmountGained ?? 0;
    const incomeRemaining = item.incomeAmountRemaining ?? 0;
    const mainTotal = isIncomeBudget ? incomeTotal : item.variant?.amount ?? 0;
    const mainSpent = isIncomeBudget ? incomeSpent : item.amountSpent ?? 0;
    const mainRemaining = isIncomeBudget ? incomeRemaining : item.amountRemaining ?? 0;
    const color = item.variant ? undefined : "#888";
    const bg = "white";
    return (
        <Paper elevation={0} sx={{ mb: 1, borderRadius: 2, p: 1, background: bg, color }} onClick={props.OnClick}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 500 }}>{item.description}</Typography>
                <Typography variant="body2">{mainTotal.toLocaleString(undefined, { minimumFractionDigits: 2 })}</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
                <Typography variant="body2">{`${mainSpent.toLocaleString(undefined, { minimumFractionDigits: 2 })} of ${mainTotal.toLocaleString(undefined, { minimumFractionDigits: 2 })}`}</Typography>
                <Typography variant="body2">{`${mainRemaining.toLocaleString(undefined, { minimumFractionDigits: 2 })} ${mainRemaining >= 0 ? "left" : "over"}`}</Typography>
            </Box>
            <LinearProgress variant="determinate" value={mainTotal > 0 ? Math.min(100, 100 * mainSpent / mainTotal) : 0} sx={{ height: 6, borderRadius: 3 }} />
            {isCombinedBudget && (
                <>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5, mt: 0.5 }}>
                        <Typography variant="body2">{`${incomeSpent.toLocaleString(undefined, { minimumFractionDigits: 2 })} of ${incomeTotal.toLocaleString(undefined, { minimumFractionDigits: 2 })} income`}</Typography>
                        <Typography variant="body2">{`${incomeRemaining.toLocaleString(undefined, { minimumFractionDigits: 2 })} ${incomeRemaining >= 0 ? "left" : "over"}`}</Typography>
                    </Box>
                    <LinearProgress variant="determinate" value={incomeTotal > 0 ? Math.min(100, 100 * incomeSpent / incomeTotal) : 0} sx={{ height: 6, borderRadius: 3 }} />
                </>
            )}
        </Paper>
    );
};

export default SubBudget;
